import React, { useContext, useEffect, useState } from 'react';
import { Table, ApplicationUIContext } from '@yuhuinc/ui-library';
import { Button, Divider, Space, Tag } from 'antd';
import { SafetyOutlined, EyeOutlined } from '@ant-design/icons';

import { phaseTwoWip } from 'components/landlord_app/application_management/common/actions/WipModal';
import TitleWithIcon from '../common/TitleWithIcon';

const TAG_COLOURS = {
  not_invited: 'geekblue',
  not_valid: 'magenta',
  valid: 'green',
  adding_details: 'magenta',
};

const APPLICANT_INSURANCE_COLUMNS = [
  {
    title: 'Provider',
    dataIndex: 'provider',
    key: 'provider',
  },
  {
    title: 'Policy End',
    dataIndex: 'expiry_date',
    key: 'expiry_date',
  },
  {
    title: 'Coverage',
    dataIndex: 'coverage',
    key: 'coverage',
  },
  {
    title: 'Status',
    dataIndex: 'status',
    key: 'status',
    render(value) {
      return <Tag color={TAG_COLOURS[value]}>{value}</Tag>;
    },
  },
  {
    key: 'document_link',
    render(value) {
      return <Button type="link" icon={<EyeOutlined />} />;
    },
  },
];

const ApplicationInsurance = ({ cotenantId }) => {
  const [insurance, setInsurance] = useState([]);
  const { isMobile } = useContext(ApplicationUIContext);

  useEffect(() => {
    // TODO: fetch insurance
  }, [cotenantId]);

  return (
    <>
      <Divider />
      <Space direction="vertical" style={{ width: '100%' }}>
        <TitleWithIcon icon={<SafetyOutlined />} text="Insurance" />
      </Space>

      {!insurance?.length ? (
        <Button
          type="default"
          size="medium"
          onClick={() => {
            phaseTwoWip(() => {});
          }}
        >
          Add Insurance
        </Button>
      ) : (
        <Table
          dataSource={insurance}
          columns={APPLICANT_INSURANCE_COLUMNS}
          hideActionAndSearch
          size={isMobile ? 'middle' : 'small'}
          scroll={{
            x: isMobile,
          }}
          pagination={{ hideOnSinglePage: true }}
        />
      )}
    </>
  );
};

export default ApplicationInsurance;
